module.exports = __webpack_public_path__ + "img/02.325d20ea.png";